export enum CouponSubCategory {
  free_coupon = 40001, // 免配券
  allotment_coupon = 40002 //减配券
}

export enum CouponReminderInfoType {
  payment_restriction = 1, // 支付渠道限制
  payment_user_version_old = 2, // 支付渠道限制的券在低版本不可用
}

export enum PreUseCouponStatus {
  coupon_unuseable = 0, // 券不可用
  coupon_useable = 1, // 券可用
}

/**
 * 页面来源
 */
export enum PageSourceType {
  MY_COUPON_LIST = 1, // 我的券列表
  ORDER_COUPON_LIST = 2, // 提单券列表
  HISTORY_COUPON_LIST = 3, // 历史券列表
}
